// extracted by mini-css-extract-plugin
export default {"assigneeFilterButton":"ListAssigneeFilter-module__assigneeFilterButton--mq5TL"};